import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { isChannel } from "@website/utils/channel/helpers";
type MainLinkProps = {
  href: string;
  title: string;
  img: string;
  imgMobile: string;
};
export const MainLink = t0 => {
  const $ = _c(24);
  const {
    href,
    title,
    img,
    imgMobile
  } = t0;
  let t1;
  if ($[0] !== imgMobile) {
    t1 = <source media="(max-width: 1024px)" sizes="(max-width: 1024px) 456px, 292px" srcSet={imgMobile} />;
    $[0] = imgMobile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== img || $[3] !== title) {
    t2 = <img className="rounded-lg lg:h-[456px] lg:w-[292px]" src={img} alt={title} />;
    $[2] = img;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <picture className="order-3">{t1}{t2}</picture>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== title) {
    t4 = <span className="text-subtitle-1 text-on-surface-high-emphasis flex items-center">{title}</span>;
    $[8] = title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="bg-on-surface-high-emphasis flex h-9 w-9 shrink-0 items-center justify-center rounded-lg"><MaterialIcon name="chevron_left" className="text-2xl text-white" /></div>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = <div className="flex w-full justify-between text-nowrap rounded-lg bg-white lg:absolute lg:bottom-6 lg:left-1/2 lg:w-60 lg:-translate-x-1/2 lg:px-3 lg:py-2 xl:w-[268px]">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== href || $[14] !== t6) {
    t7 = <a href={href} className="order-1 flex h-full flex-col-reverse gap-4 pb-4 lg:block">{t6}</a>;
    $[13] = href;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== href) {
    t8 = isChannel(["website"]) && href === "/villa" && <a href="/villa/villa-host" rel="nofollow" className="max-sm:border-outline-thin order-2 flex w-full justify-between gap-8 text-nowrap rounded-lg bg-white pt-4 max-lg:mb-4 max-lg:pb-4 max-sm:border-t lg:absolute lg:bottom-[84px] lg:left-1/2 lg:w-60 lg:-translate-x-1/2 lg:px-3 lg:py-2 xl:w-[268px]"><span className="text-subtitle-1 text-on-surface-high-emphasis flex items-center">ورود به پنل میزبان ویلا</span><div className="bg-on-surface-high-emphasis flex h-9 w-9 shrink-0 items-center justify-center rounded-lg"><MaterialIcon name="chevron_left" className="text-2xl text-white" /></div></a>;
    $[16] = href;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <div>{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t3 || $[22] !== t9) {
    t10 = <div className="max-lg:gap relative h-full w-full shrink-0 max-lg:flex max-lg:flex-col lg:w-64 lg:object-cover xl:w-72 xl:object-fill">{t3}{t9}</div>;
    $[21] = t3;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};